import React, { useEffect, useRef, useContext } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link, useNavigate } from "react-router-dom";
import { verifyAuth } from "../services/authservices";
import authService from "../services/authservices";
import SubFooter from "./SubFooter";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

function Privacypolicy() {
  const navigate = useNavigate();
  const [offset, setOffset] = useState(0);
  const advanceSectionRef = useRef(null);
  const [userAuth, setAuth, userAuthref] = useState(false);
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);

  const [siteDatacomes, setSiteData] = useState("");

  const [loginCheck, setloginCheck] = useState(false);

  useEffect(() => {
    getSitedata();

    let userToken = localStorage.getItem("token");
    if (userToken) {
      setloginCheck(true);
    } else {
      setloginCheck(false);
    }
  }, [0]);

  const getSitedata = async () => {
    try {
      const data = await authService.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (advanceSectionRef.current) {
        const sectionTop = advanceSectionRef.current.offsetTop;
        const sectionHeight = advanceSectionRef.current.offsetHeight;
        const pageOffset = window.pageYOffset;

        if (
          pageOffset >= sectionTop &&
          pageOffset <= sectionTop + sectionHeight
        ) {
          setOffset(pageOffset - sectionTop);
        } else {
          setOffset(0);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    checkuserAuth();
  }, [0]);

  const checkuserAuth = async () => {
    const token = localStorage.getItem("token");
    if (token != null) {
      try {
        const data = await verifyAuth(token);
        if (data && data.status) {
          setAuth(true);
        } else {
          setAuth(false);
        }
      } catch (error) {
        console.error("Error auth user details:", error);
        setAuth(false);
      }
    } else {
      setAuth(false);
    }
  };

  const nav_page = () => {
    if (!userAuthref.current) {
      navigate("/register");
    } else {
      navigate("/home");
    }
  };

  return (
    <>
      <main className="wyscale_landing_main">
        <section>
          <Header />
        </section>
        <section className="dashboard_content_section">
          <div className="container">
            <div className="smart_dashboard_content" id="privacy-condition">
              <h2>{t("BinargePrivacy")}</h2>
              <p>{t("Updated_date")}</p>
              <div className="row">
                <div className="col-lg-12">
                  <div className="dash_board_profile_content">
                    <div className="contentpage">
                      {/*
                        <p>
                        Binarge ("Binarge," "we," "our," or "us") values your privacy and is committed to transparency regarding how we handle data. This Privacy Policy applies to information we collect when you use our website and other online services that link to this Privacy Policy (collectively, the "Services").
                        </p>
                      */}

                      <h3>1. {t("Intro")}</h3>
                      <p>{t("HowBinarge1")}</p>
                      <p>{t("HowBinarge2")}</p>
                      <p>{t("HowBinarge3")}</p>

                      <h3>2. {t("Data_We_Collect")}</h3>
                      <h3> {t("a)Personal_Information")}</h3>
                      <ul>
                        <li>{t("Na_me")}</li>
                        <li>{t("Email_address")}</li>
                        <li>{t("Contact_details")}</li>
                        <li>{t("Support_correspondence")}</li>
                      </ul>
                      <h3> {t("b)Usage_Data")}</h3>
                      <ul>
                        <li>{t("IP_address")}</li>
                        <li>{t("Browser_device_details")}</li>
                        <li>{t("Pages_visited")}</li>
                        <li>{t("Referral_URLs")}</li>
                        <li>{t("Session_time")}</li>
                       {t("Cookie_preferences") && <li>{t("Cookie_preferences")}</li>}
                      </ul>
                      <h3>{t("c)APIKey_Information")}</h3>
                      <p>{t("trade-only")}</p>
                      <ul>
                        <li>{t("Withdrawal_rights")}</li>
                        <li>{t("encrypted_Both")}</li>
                        <li>{t("trading_balances")}</li>
                      </ul>
                      <h3>{t("d)Payment&Billing Data")}</h3>
                      <p>{t("third-party_providers")}</p>
                      <p>{t("credit_card")}</p>

                      <h3>{t("e)Pre-Payment_Balance_(Service Credit)")}</h3>
                      {t("subscription_fees") && <p>{t("subscription_fees")}</p>}
                      {t("crypto-asset") && <p>{t("crypto-asset")}</p>}
                      {t("PP_instruct") && <p>{t("PP_instruct")}</p>}
                      {t("PP_instruct_follows") && <p>{t("PP_instruct_follows")}</p>}
                      {t("PP_instruct_follows_List1") && <ul>
                        {t("PP_instruct_follows_List1") && <li>{t("PP_instruct_follows_List1")}</li>}
                        {t("PP_instruct_follows_List2") && <li>{t("PP_instruct_follows_List2")}</li>}
                      </ul>}
                      {t("Pre_payment_cli") && <p>{t("Pre_payment_cli")}</p>}

                      <h3>{t("f)Affiliate_Rewards")}</h3>
                      <p>{t("affiliate_payments")}</p>
                      <p>{t("independent")}</p>

                      <h3>3. {t("How_Information")}</h3>
                      {t("WeUseData") && <p>{t("WeUseData")}</p>}
                      <ul>
                        <li>{t("manage_your_account")}</li>
                        <li>{t("non-custodial_automation")}</li>
                        <li>{t("API_connectivity(trade-only)")}</li>
                        <li>{t("Improve_performance")}</li>
                        <li>{t("Handle_subscription")}</li>
                        <li>{t("system_notifications")}</li>
                        {t("Ensure_security") && <li>{t("Ensure_security")}</li>}
                        {t("anti-fraud_rulez") && <li>{t("anti-fraud_rulez")}</li>}
                      </ul>
                      <p>{t("investment_decisions")}</p>

                      <h3>4. {t("Cookiez")}</h3>
                      <p>{t("personalize_marketing")}</p>
                      <h3>{t("Types_of_cookies")}</h3>
                      <ul>
                        <li>{t("Essential_cookies")}</li>
                        <li>{t("Analytics_cookies")}</li>
                        <li>{t("Marketing_cookies")}</li>
                      </ul>
                      <p>{t("browser_settings")}</p>

                      <h3>5. {t("LegalBasis")}</h3>
                      {t("legal_grounds") && <p>{t("legal_grounds")}</p>}
                      <ul>
                        <li>{t("Contract_performance")}</li>
                        <li>{t("Consent")}</li>
                        <li>{t("Legitimate_interest")}</li>
                        <li>{t("Legal_obligation")}</li>
                      </ul>
                      <p>{t("contract_performance")}</p>

                      <h3>6. {t("Third-Party_Service_Providers")}</h3>
                      <p>{t("limited_personal_data")}</p>
                      <ul>
                        <li>{t("Analytics_services")}</li>
                        <li>{t("Hosting_providers")}</li>
                        <li>{t("Payment_processors")}</li>
                        <li>{t("Email&communication_platforms")}</li>
                        <li>{t("Customer_support_tools")}</li>
                      </ul>
                      <p>{t("GDPR-compliant")}</p>

                      <h3>7. {t("Data_Security")}</h3>
                      {t("Industry_Standard") && <p>{t("Industry_Standard")}</p>}
                      {t("including_API_key") && <p>{t("including_API_key")}</p>}
                      <ul>
                        {t("in_transit") && <li>{t("in_transit")}</li>}
                       {t("authorized_systems") && <li>{t("authorized_systems")}</li>}
                       {t("trading_balancez") && <li>{t("trading_balancez")}</li>}
                        {t("perform_withdrawals") && <li>{t("perform_withdrawals")}</li>}
                      </ul>
                      {t("account_credentials") && <p>{t("account_credentials")}</p>}
                      {t("New_industry_follows1") && <p>{t("New_industry_follows1")}</p>}
                      {t("NI_foll") && <p>{t("NI_foll")}</p>}
                      {t("Ni_List_1") && <ul>
                        {t("Ni_List_1") && <li>{t("Ni_List_1")}</li>}
                        {t("Ni_List_2") && <li>{t("Ni_List_2")}</li>}
                        {t("Ni_List_3") && <li>{t("Ni_List_3")}</li>}
                      </ul>}
                      {t("New_industry_follows2") && <p>{t("New_industry_follows2")}</p>}
                      {t("Ni_List_4") && <ul>
                        {t("Ni_List_4") && <li>{t("Ni_List_4")}</li>}
                        {t("Ni_List_5") && <li>{t("Ni_List_5")}</li>}
                        {t("Ni_List_6") && <li>{t("Ni_List_6")}</li>}
                      </ul>}

                      <h3>8. {t("Your_Rights")}</h3>
                      <p>{t("Your_Rights_follows")}</p>
                      <ul>
                        <li>{t("Accessyourpersonal_data")}</li>
                        <li>{t("Request_correction")}</li>
                        <li>{t("Restrict_or_object")}</li>
                        <li>{t("data_portability")}</li>
                        <li>{t("Withdraw_consent")}</li>
                        <li>{t("supervisory_authority")}</li>
                      </ul>
                      <h3>9. {t("Data_Retention")}</h3>
                      <p>{t("long_necessary")}</p>
                      <ul>
                        <li>{t("deliver_the_service")}</li>
                        <li>{t("fulfil_legal_obligations")}</li>
                        <li>{t("resolve_disputes")}</li>
                        {t("enforce_agreements") && <li>{t("enforce_agreements")}</li>}
                      </ul>
                      <p>{t("Account_closure")}</p>

                      <h3>10. {t("Childrens_Privacy")}</h3>
                      <p>{t("intended")}</p>
                      <p>{t("knowingly")}</p>

                      <h3>11. {t("International_Data_Transfers")}</h3>
                      <p>{t("Standard_Contractual_Clauses")}</p>

                      <h3>12. {t("Regulatory_Position")}</h3>
                      <p>{t("software_23")}</p>
                      <p>{t("user_crypto-assets")}</p>
                      <ul>
                        <li>{t("CASP")}</li>
                        <li>{t("CARF")}</li>
                        {t("Casp2") && <li>{t("Casp2")}</li>}
                        {t("Carf") && <li>{t("Carf")}</li>}
                      </ul>
                      <p>{t("asset_custodyz")}</p>

                      <h3>13.{t("Changes_to_This_Policy")}</h3>
                      <p>{t("last_updated")}</p>

                      <h3>14.{t("Contact__Us")}</h3>
                      <p>{t("BCO")}</p>
                      <p>{t("Business__ID")}</p>
                      <p>{t("binarge__com")}</p>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SubFooter />
      </main>
    </>
  );
}

export default Privacypolicy;
